<header class="masthead" style="position: fixed;">
	<div class="navbar">
		<div class="left-header-subscribe">
				<button id="create-workspace" class="back-to-workspace" data-toggle="dropdown" class="DAM-icon" (click)="switchToWorkspace()">
					<a class="navbar-brand js-scroll-trigger" href="javascript:;"><svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
					    <title>Back</title>
					    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					        <g id="DAM-Pricing-Copy-2" transform="translate(-40.000000, -28.000000)">
					            <g id="Back" transform="translate(40.000000, 28.000000)">
					                <rect id="Rectangle-8" x="0" y="0" width="24" height="24"></rect>
					                <g id="Group-7" stroke-linecap="round" stroke-linejoin="round" transform="translate(3.000000, 6.000000)" stroke="#000000" stroke-width="1.5">
					                    <line x1="0" y1="6" x2="17.1428571" y2="6" id="Stroke-1"></line>
					                    <polyline id="Path-2" points="5.4 0 0 5.9256575 5.27460736 12"></polyline>
					                </g>
					            </g>
					        </g>
					    </g>
					</svg>
				</a>
					<span class="drop-down-option-workspace">
						Back to workspace
					</span>
				</button>
		</div>

		<div class="right-header">
			<div class="figma-icons-section">
        <div class="plugin-figma-icon">
          <button (click)="openFigma()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ic-figma.png">
          </button>
        </div>

        <div class="plugin-sketch-icon">
          <button (click)="openSketch()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ic-sketch.png">
          </button>
        </div>

        <div class="plugin-ai-icon">
          <button (click)="openIllustrator()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ai.png" style="width: 20px; height: 20px;">
          </button>
        </div>
      </div>

			<div class="menu-pop-over anticon-bell">
				<button id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon" (click)="getNotifications()">
					<img src="assets/img/ic-noti.svg">
				</button>
				<!-- <span class="dot"></span> -->
				<div class="dropdown-menu notification-area" aria-labelledby="notification-pop-over">
						<div class="dropdown-container">
							<h5 class="notification-txt" style="margin-bottom:20px;"><b>Notifications</b></h5>
							<div class="notification-item">

								<!-- <div class="" *ngIf="showLoader">
									<img src="assets/img/loader.svg" style="margin-left: auto;margin-right: auto;display: block;width: 30%;" alt="">
								</div> -->

								<div *ngIf="notifications.length == 0" class="empty-notification-area">
									<img src="assets/img/no-noti.svg" alt="">
									<span>You have no notifications</span>
								</div>


								<ul *ngFor="let noti of notifications" style="padding: 0px;">
									<li style="border-bottom: 1px solid rgba(0,0,0,0.1);padding: 16px 0 16px 0;margin: 0 16px;">
										<div class="user-details-info">
										<div class="user-img">
											<span class="ant-avatar ant-avatar-circle ant-avatar-image ant-avatar-icon" style="width: 40px; height: 40px; line-height: 40px; font-size:18px; font-weight: 500;">
												<div class="email-initial-setup" [style.background-color]="getRandomColor()">
													{{getName(noti.firstName)}}{{getName(noti.lastName)}}
												</div>
											</span>
											</div>
											<div>
												<div class="user-info-name">
													<span>{{noti.message}} <b>{{noti.firstName}} {{noti.lastName}}</b></span>
												</div>
												<div class="" style="margin-top: 4px;">
													<span class="notification-date">{{noti.timestamp.toString().split(".")[0]}}</span>
												</div>
											</div>
										</div>
									</li>
								</ul>
							</div>
					</div>
				</div>
			</div>

			<div class="menu-pop-over user-name" *ngIf="currentUser  && !mobileView">
				<button id="user-pop-over" data-toggle="dropdown" class="user-icon-btn">
					<img *ngIf="!userPic" src="assets/img/user-profile.svg">
					<img *ngIf="userPic" src="{{userPic}}">
				</button>
				<div class="dropdown-menu" aria-labelledby="user-pop-over">
					<div class="dropdown-container">
						<div class="upper-container">
							<div class="name-pro">
								<h6>{{currentUser.firstName+" "+currentUser.lastName}}</h6>
								<span class="pro">
									{{planName}}
								</span>
							</div>
							<div class="email">{{currentUser.email}}</div>
							<div *ngIf="totalSpaceAllowed <= 1000 && consumedSpaceAllowed <= 1000" class="storage-size">{{consumedSpaceAllowed | number: '1.2-2'}}MB / {{totalSpaceAllowed}}GB</div>
              <div *ngIf="totalSpaceAllowed <= 1000 && consumedSpaceAllowed > 1000" class="storage-size">{{consumedSpaceAllowed/1000 | number: '1.2-2'}}GB / {{totalSpaceAllowed}}GB</div>
							<div *ngIf="totalSpaceAllowed > 1000 && consumedSpaceAllowed > 1000" class="storage-size">{{consumedSpaceAllowed/1000 | number: '1.2-2'}}GB / {{totalSpaceAllowed/1000}}TB</div>
							<!-- <div class="storage-indicator">
								<div class="storage-indicator-color">

								</div>
							</div> -->
							<progress id="file" value="{{consumedSpaceAllowed}}" max="{{totalSpaceAllowedProgress}}"></progress>
						</div>

						<ul class="dropdown-list list-group">
							<div class="hr-line"></div>
							<a routerLink="/my-profile"><li class="list-group-item">My profile</li></a>
							<a (click)="personalClick()"><li class="list-group-item">My content hub</li></a>
							<div class="hr-line"></div>
							<a routerLink="/how-it-works" target="_blank"><li class="list-group-item">How it works</li></a>
							<a routerLink="/home" target="_blank"><li class="list-group-item">Go to Homepage</li></a>
							<a (click)="goToMarketplace()"><li class="list-group-item">Go to Marketplace</li></a>
							<a routerLink="/feedbacks" target="_blank"><li class="list-group-item">Feedback & bugs report</li></a>
							<a routerLink="/faq" target="_blank"><li class="list-group-item">FAQ</li></a>
							<a (click)="goProClick()" *ngIf="planName == 'Free'">
								<li class="list-group-item" style="background-color: var(--primaryColorLightBlue); border-radius: 4px; margin-top: 8px; display: block;"><b style="color: #2d7cff">Upgrade plan:</b><span> You're on the free plan. Upgrade now for unlimited storage, access, members, and more.</span></li>
							</a>
						</ul>
						<div class="logout-btn">
							<button type="button" class="ant-btn" (click)="logOut()"><a>Logout</a></button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</header>

<section class="price-power-section" *ngIf="customCheckoutSection">
  <div class="container">
    <div class="panel-wrapper">
      <div class="left-panel">
        <div class="box-wrapper mb-4">
          <div class="d-flex">
            <div class="img-wrpper">
              <img src="assets/img/payment.png">
            </div>
            <div class="content-wrapper">
              <h3 class="mb-0 pb-0">Ready for Crafttor Enterprise?</h3>
              <p class="upgrade-txt">Upgrade your plan and get:</p>
              <ul>
                <li><strong>Lifetime</strong> billed at ${{finalPrice}}</li>
      					<li *ngIf="totalWorkspace == 1"><strong>{{totalWorkspace}}</strong> Workspace</li>
                <li *ngIf="totalWorkspace > 1"><strong>{{totalWorkspace}}</strong> Workspaces</li>
      					<li *ngIf="totalAdmin == 1"><strong>{{totalAdmin}}</strong> Admin</li>
      					<li *ngIf="totalAdmin > 1"><strong>{{totalAdmin}}</strong> Admins</li>
                <li><strong>Unlimited</strong> boards</li>
                <li *ngIf="totalStorageSpace < 1000000"><strong>{{totalStorageSpace/1000}} GB</strong> of storage.</li>
      					<li *ngIf="totalStorageSpace > 1000000"><strong>{{totalStorageSpace/1000000}} TB</strong> of storage.</li>
      					<li><strong>{{totalSeats}}</strong> seats(including owner).</li>
                <li>Marketplace access</li>
                <li>Plugins & more</li>
              </ul>
            </div>
          </div>
        </div>
      	<!-- <button id="create-workspace" data-toggle="dropdown" class="DAM-icon back-to-payment" (click)="showMainSection()">
      		<a class="navbar-brand js-scroll-trigger" href="javascript:;"><svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      				<title>Back</title>
      				<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      						<g id="DAM-Pricing-Copy-2" transform="translate(-40.000000, -28.000000)">
      								<g id="Back" transform="translate(40.000000, 28.000000)">
      										<rect id="Rectangle-8" x="0" y="0" width="24" height="24"></rect>
      										<g id="Group-7" stroke-linecap="round" stroke-linejoin="round" transform="translate(3.000000, 6.000000)" stroke="#000000" stroke-width="1.5">
      												<line x1="0" y1="6" x2="17.1428571" y2="6" id="Stroke-1"></line>
      												<polyline id="Path-2" points="5.4 0 0 5.9256575 5.27460736 12"></polyline>
      										</g>
      								</g>
      						</g>
      				</g>
      		</svg>
      	</a>
      		<span class="drop-down-option-workspace" style="margin-left: -10px;">
      			Back
      		</span>
      	</button> -->
      </div>
      <div class="right-panel">
        <div class="box-wrapper">
          <div class="plane-summary">
            <h3>Plan summary</h3>
            <table>
              <tbody>
                    <tr>
                      <td>
                        <input type="radio" name="subscription" value="yearly" id="yearly" [checked]="detailsYearly">
                        <label for="yearly">Lifetime
													<!-- <div class="badge">Save 20%</div> -->
												</label>
                      </td>
                      <td>
                        <div class="price">${{finalPrice}}</div>
                      </td>
                    </tr>
                  <tr>
                    <td colspan="2" class="coupon-box">
                    <div class="collapse multi-collapse" id="multiCollapseExample1">
                      <div class="input-group">
                      <input type="text" class="form-control coupon" name="" placeholder="Coupon code">
                        <span class="input-group-append">
                          <button class="btn btn-primary btn-apply coupon">Apply</button>
                        </span>
                      </div>
                    </div>
                    </td>
                  </tr>
                <tr class="user">
                  <td><p>{{totalSeats}} users on lifetime plan</p></td>
                  <td><p class="small"><b>${{finalPrice}}</b></p>
                  </td>
                </tr>

                <tr class="total">
                  <td><p>Total</p></td>
                  <td>
                    <div class="price"><h4>${{finalPrice}}</h4></div>
                  </td>
                </tr>
                <tr class="button-wrapper">
      						<td colspan="2">
      							<!-- Stripe Code -->
                     <!-- <a class="button" href="javascript:;" (click)="checkoutStripe()">Upgrade</a> -->

                     <!-- Razorpay -->
                     <a class="button" href="javascript:;" (click)="createRzpayOrder()">Upgrade</a>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <p class="small" style="font-size: 12px;">By confirming your subscription, you allow Crafttor to charge your card for this payment in accordance with their terms.</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="loader-scenarios" *ngIf="showTopRightLoader">
        <img class="img-up-loader" style="width: 30px;" src="assets/img/img-up.svg" alt="">
      </div>

      <div class="loader-scenarios-success-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessfulMsg">
        <span class="ant-avatar-selected">
          <svg width="18" height="14" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 5L4.58824 9L13 1" stroke="#0fa636" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <p>{{successfullMessage}}</p>
      </div>

      <div class="loader-scenarios-error-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessfulErrorMsg">
        <p>{{sendSuccessfulErrorMessage}}</p>
      </div>

    </div>
  </div>
</section>

<section class="checkout-login-section" *ngIf="showNotPageExist">
  <div class="background container-fluid">
    <div class="container main-heading-maintain">
      <img src="assets/img/no-exist.svg" style="width: 400px;" alt="">
      <h2>Link expired or page does not exist!!</h2>
    </div>
  </div>
</section>

<section class="payment-success-section" *ngIf="paymentSuccessSection">
	<div class="container">
		<div class="row">
			<div class="col-sm-12 text-center">
				<div class="img-container">
					<img src="assets/img/confirmed.svg">
          <h1>${{math.trunc(finalPrice)}}</h1>
					<h5>Your Payment is Successful!</h5>
					<p>Payment details are sent to your email.</p>
					<a href="javascript:;" class="button" (click)="switchToWorkspace()">Go to Workspace</a>
				</div>
			</div>
		</div>
	</div>
</section>
